import React, { useState, useEffect } from "react"
import $ from "jquery"

import FacebookLogo from "../svgs/facebook-logo.svg"
import TwitterLogo from "../svgs/twitter-logo.svg"
import LinkedinLogo from "../svgs/linkedin-logo.svg"
import ShareLogo from "../svgs/share-logo.svg"
import Toast from "react-bootstrap/Toast";


const SocialMediaWidget = (props) => {

    const [positionStyles, setPositionStyles] = useState({ position: 'absolute' })

    const [showCopyTextToast, setShowCopyTextToast] = useState(false);

    const toggleCopyTextToast = () => {
        setShowCopyTextToast(false)
    }
    const copyLink = () => {
        navigator.clipboard.writeText(`https://www.whytespyder.com/blog/${props.slug}`);
        setShowCopyTextToast(true);
    }

    useEffect(() => {
        document.addEventListener('scroll', () => {
            if ($(document).scrollTop() <= $('#page-banner').height()) {
                setPositionStyles({ position: 'absolute' })
            }
            else if ($(document).scrollTop() >= $('#blog-content').height() + $('#page-banner').height() - $('#social-media-widget').height()) {
                setPositionStyles({ position: 'absolute', bottom: '0' })
            }
            else {
                setPositionStyles({ position: 'fixed', top: 'calc(5rem + 70px)' })
            }
        })
    }, [])

    return (

        <div id='social-media-widget' style={{ ...positionStyles, transition: 'all 2s ease' }}>
            <p className='text-primary text-uppercase text-center'>Share</p>
            <a className='d-flex' href={`https://www.facebook.com/sharer/sharer.php?u=https://www.whytespyder.com/blog/${props.slug}`} target="_blank" rel="noreferrer">
                <FacebookLogo className='mb-4 mx-auto' />
            </a>
            <a className='d-flex' href={`https://twitter.com/intent/tweet/?text=${props.title}&url=https://www.whytespyder.com/blog/${props.slug}`} target="_blank" rel="noreferrer">
                <TwitterLogo className='mb-4 mx-auto' />
            </a>
            <a className='d-flex' href={`https://www.linkedin.com/shareArticle?mini=true&url=https://www.whytespyder.com/blog/${props.slug}&title=${props.title}&source=${props.title}`} target="_blank" rel="noreferrer">
                <LinkedinLogo className='mb-4 mx-auto' />
            </a>

            <span role="button" id="copyTextToastBtn" className='d-flex m-0 p-0' style={{ border: 'none' }}><ShareLogo className='mb-4 mx-auto' onClick={copyLink} /></span>

            <ToastComponent show={showCopyTextToast} toggle={toggleCopyTextToast} />

            <p className='text-primary text-uppercase text-center'>Subscribe</p>
        </div>

    )
}

export default SocialMediaWidget

const ToastComponent = ({ show, toggle }) => {
    if (!show) return null;
    return (
        <Toast className="position-fixed bottom-0 start-0 m-3" style={{ zIndex: '11' }} show={show} onClose={toggle} autohide={true}>
            <Toast.Header className='text-white bg-primary border-0' closeVariant='white'>
                <strong className="me-auto">Text copied to clipboard</strong>
            </Toast.Header>
        </Toast>
    )
}